import { useCallback, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  TableConfigProvider,
  type TableError,
} from '@repo/ui/lib/table-config';
import { SKIP, TAKE } from '@/lib/constants/pagination';
import { getErrorMessage } from '@/lib/utils/error-handler';

const PAGINATION = { skip: SKIP, take: TAKE };

/**
 * Configurazione delle tabelle di `@repo/ui` per il backoffice: la
 * paginazione della sua API e gli errori tradotti come nel resto dell'app.
 * L'importo della selezione lo rende il package (`SignedAmount`), come nella
 * webapp.
 */
export function BackofficeTableConfigProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { t } = useTranslation();
  const formatError = useCallback(
    (error: TableError) => getErrorMessage(error, t),
    [t]
  );

  return (
    <TableConfigProvider pagination={PAGINATION} formatError={formatError}>
      {children}
    </TableConfigProvider>
  );
}
